import {
  Flex,
  Box,
  Text,
  useBreakpointValue,
  Center,
  Divider,
} from "@chakra-ui/react";
import { GCChannel } from "../../../types";
import { StreamTabs } from "../../../components/tabs/StreamTabs";
import { useSubHeaderScroll } from "../../../hooks/useSubHeaderScroll";

interface HeaderNavigationBarProps {
  showChannelName: boolean;
  activeChannel: GCChannel;
  activeStreamId?: string;
}

export function HeaderNavigationBar({
  showChannelName,
  activeChannel,
  activeStreamId,
}: HeaderNavigationBarProps) {
  const { stickyTop: subHeaderTop, stickyTransform, stickyTransition } =
    useSubHeaderScroll();

  const showStreams = activeChannel.streams.length > 1;

  return (
    <Box
      width="100%"
      zIndex={1}
      position="sticky"
      top={subHeaderTop}
      transform={stickyTransform}
      transition={stickyTransition}
      backgroundColor="charcoal.charcoal"
      display="flex"
    >
      <StreamTabHeader
        activeChannel={activeChannel}
        activeStreamId={activeStreamId}
        showChannelName={showChannelName}
        showStreams={showStreams}
      />
    </Box>
  );
}

export function StreamTabHeader({
  activeChannel,
  activeStreamId,
  showChannelName = false,
  showStreams = false,
}: {
  activeChannel: GCChannel;
  activeStreamId?: string;
  showChannelName?: boolean;
  showStreams?: boolean;
}) {
  const shouldWrap = useBreakpointValue({ base: true, md: false });
  return (
    <Flex width="100%" pt={{ base: 4, lg: 8 }} pb={4}>
      {showChannelName && (
        <Box bgColor="charcoal.charcoal" pl={{ base: 4, lg: 0 }}>
          <Flex
            direction={!shouldWrap ? "row" : "column"}
            alignItems={!shouldWrap ? "center" : "flex-start"}
          >
            <Flex
              flexDirection="row"
              alignItems="center"
              width="auto"
              flexShrink={0}
              flexWrap="nowrap"
              gap={{ base: 3, md: 4 }}
            >
              <img
                src={activeChannel.config[0].icon} // Always retrieving dark mode icon
                alt="channel icon"
                style={{ width: "38px", height: "auto" }}
              />

              <Text
                variant="navbar"
                color="dune.dune"
                fontWeight={700}
                fontSize={{ base: "18px", md: "24px" }}
                align="center"
                whiteSpace="nowrap"
              >
                {activeChannel.display_name}
              </Text>
              {!shouldWrap && (
                <Center height="40px">
                  <Divider
                    height="40px"
                    orientation="vertical"
                    pl={2}
                    visibility={
                      activeChannel.streams.length > 1 ? "visible" : "hidden"
                    }
                  />
                </Center>
              )}
            </Flex>
          </Flex>
        </Box>
      )}
      {showStreams && (
        <Box
          flex="1"
          overflowX="auto"
          bgColor="charcoal.charcoal"
          pl={{ base: 3, lg: 0 }}
        >
          <StreamTabs
            streams={activeChannel.streams}
            activeStreamId={activeStreamId}
          />
        </Box>
      )}
    </Flex>
  );
}
